module.exports = __webpack_public_path__ + "img/Logo_accesspark.6e0e6915.png";